'use client';

import { styled } from '@linaria/react';
import CalendarIcon from '@fe-common-ui/Icons/Calendar/Calendar';
import NewsListCardSkeleton from '@fe-news/components/molecules/NewsCollectContent/NewsListCardSkeleton';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

const NewsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`;

const View = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

const Today = styled.div`
  font-size: 20px;
  color: #515c69;
  line-height: 1.2;
  font-weight: 400;
`;

const NewsCollectContentSkeleton = () => {
  return (
    <Content>
      <View>
        <CalendarIcon timestamp={Date.now()} marginRight={8} />
        <Today>今天</Today>
      </View>
      <NewsListContainer>
        {Array.from({ length: 10 }).map((_, index) => (
          <NewsListCardSkeleton key={index} />
        ))}
      </NewsListContainer>
    </Content>
  );
};

export default NewsCollectContentSkeleton;
